/** Hash `#/…` à restaurer après un retour OAuth (HashRouter + redirect sans hash). */
export const POST_AUTH_HASH_KEY = 'opuslab_post_auth_hash'

export function prepareUrlBeforeOAuthRedirect() {
  if (typeof window === 'undefined') return
  const { origin, pathname, search, hash } = window.location
  if (!hash) return
  try {
    sessionStorage.setItem(POST_AUTH_HASH_KEY, hash)
  } catch {
    /* ignore */
  }
  window.history.replaceState(null, '', `${origin}${pathname}${search}`)
}

export function restorePostAuthHashAfterOAuth() {
  if (typeof window === 'undefined') return
  try {
    const saved = sessionStorage.getItem(POST_AUTH_HASH_KEY)
    if (!saved) return
    sessionStorage.removeItem(POST_AUTH_HASH_KEY)
    if (!window.location.hash) {
      window.history.replaceState(
        null,
        '',
        `${window.location.pathname}${window.location.search}${saved}`,
      )
    }
  } catch {
    /* ignore */
  }
}

/** Nettoie l’URL après traitement OAuth (évite un second getRedirectResult incohérent). */
export function stripOAuthQueryParamsFromUrl() {
  if (typeof window === 'undefined') return
  const { search, pathname, hash } = window.location
  if (!search || !/[?&](apiKey|authType|code|state|lang)=/.test(search)) return
  window.history.replaceState(null, '', `${pathname}${hash || ''}`)
}
